<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="5"></ucMenu>
					<div class="right_con">
						<div class="setting_main" v-if="users.pid==0">
							<p class="fb">个人信息</p>
							<div class="setiting_wrap">
								<div class="setting_line">
									<p class="txt">当前手机号：</p>
									<p class="con">{{phone_show}}<i class="iconfont icon-edit" @click="is_phone = true"></i></p>
								</div>
								<div class="setting_line">
									<p class="txt">登录密码：</p>
									<p class="con">***********<i class="iconfont icon-edit" @click="is_password = true"></i></p>
								</div>
								<div class="setting_line" v-if="false">
									<p class="txt">发货运费：</p>
									<p class="con">{{supplier_drawing_bill}}元<i class="iconfont icon-edit" @click="is_supplier_drawing_bill = true"></i></p>
								</div>
								<div class="setting_line">
									<p class="txt">接收公众号提醒：</p>
									<p class="con">
										<el-switch
											v-model="switchTab"
											active-color="#13ce66"
											inactive-color="#ccc"
											@change="switchChange()">
										</el-switch>
									</p>
								</div>
							</div>
							<div class="add_wrap" v-if="false">
								<div class="title_line">
									<p class="title"><img class="icon_ali" src="../../assets/images/zhifubao.png" />支付宝账户</p>
									<p class="btn" @click="zfbOpt_add()">新增</p>
								</div>
								<div class="add_list" v-if="zfbList.length>0">
									<div class="ali_con" :class="item.xuanze?'sel':''" v-for="(item,index) in zfbList" :key="index" @click="zfbOpt_set(index)">
										<el-descriptions labelClassName="la_style" contentClassName="con_style" :colon="false" :column="1" >
											<el-descriptions-item label="支付宝账户：">{{item.zfbMember}}</el-descriptions-item>
											<el-descriptions-item label="用户名：">{{item.zfbName}}</el-descriptions-item>
										</el-descriptions>
										<div class="opts">
											<span @click.stop="zfbOpt_edit(index)">修改</span>
											<em>/</em>
											<span @click.stop="zfbOpt_delete(index)">删除</span>
										</div>
									</div>
								</div>
								<div class="nodata" v-else>暂未添加支付宝账户</div>
							</div>
							<div class="add_wrap" v-if="false">
								<div class="title_line">
									<p class="title"><img class="icon_ali" src="../../assets/images/bank.png" />银行卡</p>
									<p class="btn" @click="bankOpt_add()">新增</p>
								</div>
								<div class="add_list" v-if="bankList.length>0">
									<div class="bank_con" :class="item.xuanze?'sel':''" v-for="(item,index) in bankList" :key="index" @click="bankOpt_set(index)">
										<el-descriptions labelClassName="la_style" contentClassName="con_style"
										:colon="false" :column="1" >
											<el-descriptions-item label="用户名：">{{item.yhkName}}</el-descriptions-item>
											<el-descriptions-item label="银行卡号：">{{item.yhkMember}}</el-descriptions-item>
											<el-descriptions-item label="开户行：">{{item.yh_name}}</el-descriptions-item>
										</el-descriptions>
										<div class="opts">
											<span @click.stop="bankOpt_edit(index)">修改</span>
											<em>/</em>
											<span @click.stop="bankOpt_delete(index)">删除</span>
										</div>
									</div>
								</div>
								<div class="nodata" v-else>暂未添加银行账户</div>
							</div>
						</div>
						<el-empty description="暂无权限！" v-else></el-empty>
					</div>
				</div>
				<!--修改手机号-->
				<div :class="is_phone?'phone_mask active' : 'phone_mask'" @click.self="is_phone = false">
					<div class="phone_main">
						<i class="iconfont icon-guanbi" @click.self="is_phone = false"></i>
						<p class="title">修改手机号</p>
						<el-input v-model="phone_code" placeholder="输入验证码" class="el_input el_in2">
							<p slot="prefix" class="txts">原手机验证码</p>
							<p slot="suffix" class="getcode" @click.self="getPhoneCode('3')">{{is_get_phone_code?phone_second+'s重新获取':'获取验证码'}}</p>
						</el-input>
						<p class="tips">验证码将发送至登录手机号{{phone_show}}</p>
						<el-input v-model="new_phone" placeholder="输入新手机号" class="el_input el_in2">
							<p slot="prefix" class="txts">新手机号码</p>
						</el-input>
						<div class="btn_wrap">
							<p class="btn" @click.self="is_phone = false">取消</p>
							<p class="btn" @click="changePhone()">确定</p>
						</div>
					</div>
				</div>
				<!--修改密码-->
				<div :class="is_password?'password_mask active' : 'password_mask'" @click.self="is_password = false">
					<div class="password_main">
						<i class="iconfont icon-guanbi" @click.self="is_password = false"></i>
						<p class="title">修改密码</p>
						<el-input v-model="old_pwd" placeholder="输入密码" class="el_input el_in2">
							<p slot="prefix" class="txts">原登录密码</p>
						</el-input>
						<el-input v-model="new_pwd" placeholder="输入新密码" class="el_input el_in2">
							<p slot="prefix" class="txts">新密码</p>
						</el-input>
						<el-input v-model="new_pwd_confirm" placeholder="再次输入确密码" class="el_input el_in2">
							<p slot="prefix" class="txts">确认密码</p>
						</el-input>
						<div class="btn_wrap">
							<p class="btn" @click.self="is_password = false">取消</p>
							<p class="btn" @click="changePwd()">确定</p>
						</div>
					</div>
				</div>
				<!--新增支付宝账号-->
				<div :class="is_addAli?'addAli_mask active' : 'addAli_mask'" @click.self="is_addAli = false">
					<div class="addAli_main">
						<i class="iconfont icon-guanbi" @click.self="is_addAli = false"></i>
						<p class="title"><img class="icon" src="../../assets/images/zhifubao.png" />{{zfbOptType==1?'绑定':'修改'}}支付宝</p>
						<el-input v-model="zfbMember" placeholder="输入支付宝账号" class="el_input el_in3">
							<p slot="prefix" class="txts">支付账号</p>
						</el-input>
						<el-input v-model="zfbName" placeholder="输入用户名" class="el_input el_in3">
							<p slot="prefix" class="txts">用户名</p>
						</el-input>
						<el-input v-model="phone" placeholder="输入手机号" class="el_input el_in3" readonly>
							<p slot="prefix" class="txts">手机号码</p>
						</el-input>
						<el-input v-model="zfbCode" placeholder="输入短信验证码" class="el_input el_in3">
							<p slot="prefix" class="txts">验证码</p>
							<p slot="suffix" class="getcode" @click.self="getPhoneCode('5')">{{is_get_phone_code?phone_second+'s重新获取':'获取验证码'}}</p>
						</el-input>
						<div class="btn_wrap">
							<p class="btn" @click.self="is_addAli = false">取消</p>
							<p class="btn" @click.self="zfbOpt(zfbOptType)">确定</p>
						</div>
					</div>
				</div>
				<!--新增银行卡-->
				<div :class="is_addBank?'addBank_mask active' : 'addBank_mask'" @click.self="is_addBank = false">
					<div class="addBank_main">
						<i class="iconfont icon-guanbi" @click.self="is_addBank = false"></i>
						<p class="title"><img class="icon" src="../../assets/images/bank.png" />{{bankOptType==1?'绑定':'修改'}}银行卡</p>
						<el-select class="el_input el_in3 el_sel" v-model="bankNameId" placeholder="请选择">
							<p slot="prefix" class="txts">所属银行</p>
							<el-option v-for="(item,index) in usableBank" :key="index" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-input v-model="bankUserName" placeholder="输入开户名" class="el_input el_in3">
							<p slot="prefix" class="txts">开户名</p>
						</el-input>
						<el-input v-model="bankUserCard" placeholder="输入银行卡账号" class="el_input el_in3">
							<p slot="prefix" class="txts">银行卡号</p>
						</el-input>
						<el-input v-model="phone" placeholder="输入手机号" class="el_input el_in3">
							<p slot="prefix" class="txts">手机号码</p>
						</el-input>
						<el-input v-model="bankPhoneCode" placeholder="输入短信验证码" class="el_input el_in3">
							<p slot="prefix" class="txts">验证码</p>
							<p slot="suffix" class="getcode" @click.self="getPhoneCode('6')">{{is_get_phone_code?phone_second+'s重新获取':'获取验证码'}}</p>
						</el-input>
						<div class="btn_wrap">
							<p class="btn" @click.self="is_addBank = false">取消</p>
							<p class="btn" @click.self="bankOpt(bankOptType)">确定</p>
						</div>
					</div>
				</div>
				<!--修改运费-->
				<div :class="is_supplier_drawing_bill?'dialog_mask active' : 'dialog_mask'" @click.self="is_supplier_drawing_bill = false">
					<div class="dialog_main">
						<i class="iconfont icon-guanbi" @click.self="is_supplier_drawing_bill = false"></i>
						<p class="title">修改发货运费</p>
						<el-input v-model="supplier_drawing_bill" placeholder="输入发货运费" class="el_input el_in2">
							<p slot="prefix" class="txts">发货运费</p>
						</el-input>
						<div class="btn_wrap">
							<p class="btn" @click.self="is_supplier_drawing_bill = false">取消</p>
							<p class="btn" @click="changeSupplierDrawingBill()">确定</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>
	</div>
</template>

<script>
import { mapActions,mapState } from "vuex";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import common from '../../assets/js/utils/common';

export default {
	name: "ucenterSetting",
	data() {
		return {
			is_phone:false,
			is_password:false,
			is_supplier_drawing_bill:false,
			is_addAli:false,
			is_addBank:false,
			switchTab: true,
			phone_show:"",
			phone:"",
			phone_code:"",
			new_phone:"",
			old_pwd:"",
			new_pwd:"",
			new_pwd_confirm:"",
			is_get_phone_code:false,
			phone_second:60,
			is_phone_submit:false,
			is_pwd_submit:false,
			is_zfb_submit:false,
			is_bank_submit:false,
			zfbList:[],
			zfbMember:"",
			zfbName:"",
			zfbCode:"",
			zfbCurIndex:0,
			zfbCurId:"",
			zfbOptType:"1",
			bankList:[],
			bankNameId:"",
			bankUserName:"",
			bankUserCard:"",
			bankPhoneCode:"",
			bankCurIndex:0,
			bankCurId:"",
			bankOptType:"1",
			usableBank: [],
			supplier_drawing_bill: 0
		}
	},
	components:{
		myHead,myFoot,ucMenu
	},
	computed:{
		...mapState({
			users:(state)=>state.login.userinfo,
		}),
	},
	created(){
		this.init()
	},
	methods: {
		...mapActions({
			getCodeData:"login/getCodeData",
			getUserinfoData:"ucenter/getUserinfoData",
			doChangePhone:"ucenter/doChangePhone",
			doChangePwd:"ucenter/doChangePwd",
			doChangeSupplierDrawingBill:"ucenter/doChangeSupplierDrawingBill",
			doChangeRemind:"ucenter/doChangeRemind",
			GetZfbList:"ucenter/GetZfbList",
			doZfbAdd:"ucenter/doZfbAdd",
			doZfbDelete:"ucenter/doZfbDelete",
			doZfbEdit:"ucenter/doZfbEdit",
			doZfbSet:"ucenter/doZfbSet",
			GetUsableBank:"ucenter/GetUsableBank",
			GetBankList:"ucenter/GetBankList",
			doBankAdd:"ucenter/doBankAdd",
			doBankDelete:"ucenter/doBankDelete",
			doBankEdit:"ucenter/doBankEdit",
			doBankSet:"ucenter/doBankSet",

		}),
		init(){//初始化
			this.getUserinfoData({data:{},success:(res)=>{
				if(res.code===200){
					console.log('update userinfo success',res)
					this.phone = res.data.mobile
					this.phone_show = res.data.mobile.substr(0,3) + '****' + res.data.mobile.substr(7)
					// this.supplier_drawing_bill = res.data.supplier_drawing_bill
					this.supplier_drawing_bill = res.data.freight_price
					this.switchTab = res.data.is_we_remind==1?true:false
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
			this.getZfb()
			this.getBank()
			this.getUsableBank()
		},
		changePhone(){//修改手机号提交按钮
			if(!this.phone_code){
				this.$message({message: '请输入短信验证码',type: 'error',});
				return false
			}
			if(!this.new_phone){
				this.$message({message: '请输入新手机号码',type: 'error',});
				return false
			}
			if(!common._verify_mobile(this.new_phone)){
				this.$message({message: '请输入正确手机号',type: 'error',});
				return false
			}
			if(!this.is_phone_submit){
				this.is_phone_submit = true
				this.doChangePhone({data:{
						mobile:this.phone,
						code:this.phone_code,
						new_mobile:this.new_phone,
					},success:(res)=>{
					console.log('change pwd success',res)
					if(res.code===200){
						this.$message({message: '修改成功~',type: 'success',});
						this.is_phone = false
						this.phone = this.new_phone
						this.phone_show = this.new_phone.substr(0,3) + '****' + this.new_phone.substr(7)
						this.is_get_phone_code = false
						this.phone_second = 60
						this.is_phone_submit = false
						this.phone_code = ""
						this.new_phone = ""
					} else {
						this.$message({message: res.msg,type: 'error',});
						this.is_phone_submit = false
					}
				}})
			}
		},
		changePwd(){//修改密码提交按钮
			if(!this.old_pwd){
				this.$message({message: '请输入原密码',type: 'error',});
				return false
			}
			if(!this.new_pwd){
				this.$message({message: '请输入新密码',type: 'error',});
				return false
			}
			if(!this.new_pwd_confirm){
				this.$message({message: '请再次输入新密码',type: 'error',});
				return false
			}
			if(this.new_pwd != this.new_pwd_confirm){
				this.$message({message: '请确保两次输入的密码一致',type: 'error',});
				return false
			}
			if(!this.is_pwd_submit){
				this.is_pwd_submit = true
				this.doChangePwd({data:{
						password:this.old_pwd,
						new_password:this.new_pwd,
						true_password:this.new_pwd_confirm,
					},success:(res)=>{
					console.log('change pwd success',res)
					if(res.code===200){
						this.$message({message: '修改成功~',type: 'success',});
						this.is_password = false
						this.old_pwd = ""
						this.new_pwd = ""
						this.new_pwd_confirm = ""
					} else {
						this.$message({message: res.msg,type: 'error',});
						this.is_pwd_submit = false
					}
				}})
			}
		},
		changeSupplierDrawingBill(){
			if(!this.supplier_drawing_bill){
				this.$message({message: '请输入发货运费',type: 'error',});
				return false
			}
			this.doChangeSupplierDrawingBill({data:{
					supplier_drawing_bill:this.supplier_drawing_bill
				},success:(res)=>{
				console.log('change pwd success',res)
				if(res.code===200){
					this.$message({message: '修改成功~',type: 'success',});
					this.is_supplier_drawing_bill = false
				} else {
					this.$message({message: res.msg,type: 'error',});
					this.is_supplier_drawing_bill = false
				}
			}})
		},
		switchChange(){//开关公众号提醒
			let type = this.switchTab?1:2
			this.doChangeRemind({data:{
					type:type,
				},success:(res)=>{
				console.log('change pwd success',res)
				if(res.code===200){
					this.$message({message: res.msg,type: 'success',});
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		getZfb(){//获取支付宝列表
			this.GetZfbList({data:{},success:(res)=>{
				if(res.code===200){
					console.log('get zfb list',res)
					this.zfbList = res.data
				} else {
					console.log(res)
				}
			}})
		},
		zfbOpt(type){//新增-修改  支付宝
			// console.log('cxcxc',this.zfbCurIndex,this.zfbOptType)
			if(!this.zfbMember){
				this.$message({message: '请输入支付宝账号',type: 'error',});
				return false
			}
			if(!this.zfbName){
				this.$message({message: '请输入支付宝用户名',type: 'error',});
				return false
			}
			if(!this.zfbCode){
				this.$message({message: '请输入短信验证码',type: 'error',});
				return false
			}
			if(!this.is_zfb_submit){
				this.is_zfb_submit = true
				if(type==1){//新增支付宝
					this.doZfbAdd({data:{
							mobile:this.phone,
							code:this.zfbCode,
							zfbMember:this.zfbMember,
							zfbName:this.zfbName
						},success:(res)=>{
						if(res.code===200){
							console.log('add zfb success',res)
							this.$message({message: res.msg,type: 'success',});
							setTimeout(()=>{
								this.is_addAli = false
								this.is_zfb_submit = false
								this.zfbMember = ""
								this.zfbName = ""
								this.zfbCode = ""
								this.getZfb()
							},500)
						} else {
							this.$message({message: res.msg,type: 'error',});
							this.is_zfb_submit = false
						}
					}})
				}else if(type==2){//修改支付宝
					this.doZfbEdit({data:{
							id:this.zfbCurId,
							mobile:this.phone,
							code:this.zfbCode,
							zfbMember:this.zfbMember,
							zfbName:this.zfbName
						},success:(res)=>{
						if(res.code===200){
							console.log('edit zfb success',res)
							this.$message({message: res.msg,type: 'success',});
							setTimeout(()=>{
								this.is_addAli = false
								this.is_zfb_submit = false
								this.zfbMember = ""
								this.zfbName = ""
								this.zfbCode = ""
								this.getZfb()
							},500)
						} else {
							this.$message({message: res.msg,type: 'error',});
							this.is_zfb_submit = false
						}
					}})
				}
			}
		},
		zfbOpt_add(){//支付宝新增按钮
			this.is_addAli = true
			this.zfbMember = ""
			this.zfbName = ""
			this.zfbCurId = ""
			this.zfbOptType = '1'
		},
		zfbOpt_edit(i){//支付宝修改按钮
			this.zfbMember = this.zfbList[i].zfbMember
			this.zfbName = this.zfbList[i].zfbName
			this.zfbCurId = this.zfbList[i].id
			this.zfbOptType = "2"
			this.is_addAli = true;
		},
		zfbOpt_delete(i){//支付宝删除按钮
			this.$confirm('是否删除该支付宝账户?', '', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'}).then(() => {
					this.doZfbDelete({data:{
							id:this.zfbList[i].id,
						},success:(res)=>{
						if(res.code===200){
							console.log('delete zfb success',res)
							this.$message({message: res.msg,type: 'success',});
							this.getZfb()
						} else {
							this.$message({message: res.msg,type: 'error',});
						}
					}})
				}).catch(() => {});
		},
		zfbOpt_set(i){//设置默认支付宝账户
			this.doZfbSet({data:{
					id:this.zfbList[i].id,
				},success:(res)=>{
				if(res.code===200){
					console.log('set default zfb success',res)
					this.$message({message: res.msg,type: 'success',});
					this.getZfb()
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		getUsableBank(){//获取银行卡列表
			this.GetUsableBank({data:{
					id:"",
				},success:(res)=>{
				if(res.code===200){
					console.log('get usable bank list',res)
					this.usableBank = res.data
				} else {
					console.log(res)
				}
			}})
		},
		getBank(){//获取银行卡列表
			this.GetBankList({data:{},success:(res)=>{
				if(res.code===200){
					console.log('get bank list',res)
					this.bankList = res.data
				} else {
					console.log(res)
				}
			}})
		},
		bankOpt(type){//新增-修改  银行卡
			if(!this.bankNameId){
				this.$message({message: '请选择所属银行',type: 'error',});
				return false
			}
			if(!this.bankUserName){
				this.$message({message: '请输入开户名',type: 'error',});
				return false
			}
			if(!this.bankUserCard){
				this.$message({message: '请输入银行卡账号',type: 'error',});
				return false
			}
			if(!this.bankPhoneCode){
				this.$message({message: '请输入短信验证码',type: 'error',});
				return false
			}
			if(!this.is_bank_submit){
				this.is_bank_submit = true
				if(type==1){//新增银行卡
					this.doBankAdd({data:{
							mobile:this.phone,
							code:this.bankPhoneCode,
							yhkMember:this.bankUserCard,
							yhkName:this.bankUserName,
							yhid:this.bankNameId,
						},success:(res)=>{
						if(res.code===200){
							console.log('add bank success',res)
							this.$message({message: res.msg,type: 'success',});
							setTimeout(()=>{
								this.is_addBank = false
								this.is_bank_submit = false
								this.bankUserCard = ""
								this.bankUserName = ""
								this.bankPhoneCode = ""
								this.getBank()
							},500)
						} else {
							this.$message({message: res.msg,type: 'error',});
							this.is_bank_submit = false
						}
					}})
				}else if(type==2){//修改银行卡
					this.doBankEdit({data:{
							id:this.bankCurId,
							mobile:this.phone,
							code:this.bankPhoneCode,
							yhkMember:this.bankUserCard,
							yhkName:this.bankUserName,
							yhid:this.bankNameId,
						},success:(res)=>{
						if(res.code===200){
							console.log('edit zfb success',res)
							this.$message({message: res.msg,type: 'success',});
							setTimeout(()=>{
								this.is_addBank = false
								this.is_bank_submit = false
								this.bankUserCard = ""
								this.bankUserName = ""
								this.bankPhoneCode = ""
								this.getBank()
							},500)
						} else {
							this.$message({message: res.msg,type: 'error',});
							this.is_bank_submit = false
						}
					}})
				}
			}
		},
		bankOpt_add(){//银行卡新增按钮
			this.is_addBank = true
			this.bankUserCard = ""
			this.bankUserName = ""
			this.bankNameId = ""
			this.bankOptType = '1'
		},
		bankOpt_edit(i){//银行卡修改按钮
			this.bankUserCard = this.bankList[i].yhkMember
			this.bankUserName = this.bankList[i].yhkName
			this.bankNameId = this.bankList[i].yhid
			this.bankCurId = this.bankList[i].id
			this.bankPhoneCode = ""
			this.bankOptType = "2"
			this.is_addBank = true;
		},
		bankOpt_delete(i){//银行卡删除按钮
			this.$confirm('是否删除该银行卡账户?', '', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'}).then(() => {
					this.doBankDelete({data:{
							id:this.bankList[i].id,
						},success:(res)=>{
						if(res.code===200){
							console.log('delete bank success',res)
							this.$message({message: res.msg,type: 'success',});
							this.getBank()
						} else {
							this.$message({message: res.msg,type: 'error',});
						}
					}})
				}).catch(() => {});
		},
		bankOpt_set(i){//设置默认银行卡账户
			this.doBankSet({data:{
					id:this.bankList[i].id,
				},success:(res)=>{
				if(res.code===200){
					console.log('set default bank success',res)
					this.$message({message: res.msg,type: 'success',});
					this.getBank()
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		getPhoneCode(ev){//获取短信验证码
			let phone = this.phone
			console.log(phone)
			if(!common._verify_mobile(phone)){
				this.$message({message: '请输入正确手机号',type: 'error',});
				return false
			}
			if(!this.is_get_phone_code){
				this.is_get_phone_code = true
				this.getCodeData({data:{
						mobile:phone,
						event:ev,
					},success:(res)=>{
					if(res.code===200){
						console.log('get phone code',res)
						this.$message({message: '发送成功~',type: 'success',});
						let timer = setInterval(()=>{
							this.phone_second -= 1
							if(this.phone_second == 0){
								clearInterval(timer)
								this.phone_second = 60
								this.is_get_phone_code = false
							}
						},1000)
					} else {
						this.$message({message: res.msg,type: 'error',});
						this.is_get_phone_code = false
					}
				}})
			}

		},
	}
}
</script>

<style scoped>
.wrap .wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}
.ucenter_main{padding: 30px 0 40px;display: flex;justify-content: space-between;flex: 1;}

.right_con{width: 980px;background: #fff;}
.setting_main{padding: 36px 40px;}
.setiting_wrap{padding-top: 20px;}
.setting_line{margin-top: 30px;display: flex;font-size: 14px;line-height: 1;}
.setting_line .txt{width: 115px;text-align: right;}
.setting_line .con{flex: 1;width: 0;margin-left: 30px;display: flex;align-items: center;}
.setting_line .con .iconfont{font-size: 16px;color: #666666;margin-left: 10px;cursor: pointer;}
.add_wrap{margin-top: 50px;padding-top: 20px;border-top: 1px solid #eee;}
.add_wrap .title_line{display: flex;justify-content: space-between;align-items: center;}
.add_wrap .title_line .title{display: flex;align-items: center;}
.add_wrap .title_line .title .icon_ali{width: 20px;height: 20px;margin-right: 8px;}
.add_wrap .title_line .title .icon_bank{width: 22px;height: 14px;margin-right: 8px;}
.add_wrap .title_line .btn{width: 74px;height: 32px;box-sizing: border-box;border: 1px solid var(--red);display: flex;justify-content: center;align-items: center;cursor: pointer;color: var(--red);font-size: 14px;margin-right: 20px;}
.add_wrap .title_line .btn:hover{background: #faedee;}
.add_wrap .add_list{margin: 0 30px;padding-top: 4px;display: flex;flex-wrap: wrap;}
.add_wrap .add_list .ali_con{width: 300px;height: 120px;box-sizing: border-box;border: 1px solid #ddd;border-radius: 4px;margin: 20px 20px 0 0;padding-top: 30px;position: relative;overflow: hidden;cursor: pointer;}
.add_wrap .add_list .bank_con{width: 400px;height: 185px;box-sizing: border-box;border: 1px solid #ddd;border-radius: 4px;margin: 20px 20px 0 0;padding-top: 30px;position: relative;overflow: hidden;cursor: pointer;}
.add_wrap .add_list .ali_con.sel ,.add_wrap .add_list .bank_con.sel{border-color: #f49492;}
.add_wrap .add_list .ali_con::before ,.add_wrap .add_list .bank_con::before{content: '\e605';font-family: "iconfont" !important;position: absolute;top: -1px;right: -1px;z-index: 22;font-size: 30px;color: #dddddd;}
.add_wrap .add_list .ali_con.sel::before ,.add_wrap .add_list .bank_con.sel::before{color: #f0413e;}

.add_wrap .add_list .opts{font-size: 14px;color: #999999;position: absolute;right: 15px;bottom: 12px;z-index: 2;display: flex;align-items: center;}
.add_wrap .add_list .opts span{cursor: pointer;}
.add_wrap .add_list .opts span:hover{color: var(--red);text-decoration: underline;}
.add_wrap .add_list .opts em{margin: 0 4px;}
.la_style{color: #333;width: 100px;justify-content: flex-end;line-height: 1;display: flex;}
.con_style{color: #333;line-height: 1;}

.phone_mask{width: 100%;height: 100%;position: fixed;top: 0;left: 0;background: rgba(0, 0, 0, .5);z-index: 999;transition: all .5s;visibility: hidden;opacity: 0;}
.phone_mask.active{visibility: visible;opacity: 1;}
.phone_mask .phone_main{width: 400px;height: 312px;box-sizing: border-box;padding: 36px 0 28px;background: #fff;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-70%);visibility: hidden;opacity: 0;transition: all .5s;}
.phone_mask.active .phone_main{transform: translate(-50%,-50%);visibility: visible;opacity: 1;}
.phone_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.phone_main .title{margin: 0 32px;font-size: 20px;line-height: 1;}
.phone_main .input_line{margin: 24px 32px 0;height: 36px;box-sizing: border-box;border: 1px solid #ddd;border-radius: 4px;display: flex;padding: 0 10px;align-items: center;}
.phone_main .input_line .txt{width: 90px;font-size: 12px;color: #999999;}
.phone_main .input_line .in{flex: 1;width: 0;font-size: 12px;color: #333;}
.phone_main .input_line .getcode{padding-left: 8px;border-left: 1px solid #eee;font-size: 12px;color: #333333;cursor: pointer;line-height: 1;}
.phone_main .tips{margin: 10px 32px 0;line-height: 1;font-size: 12px;color: #666666;}
.phone_main .btn_wrap{margin: 32px 32px 0;display: flex;justify-content: space-between;}
.phone_main .btn_wrap .btn{width: 160px;height: 40px;box-sizing: border-box;border-radius: 6px;display: flex;justify-content: center;align-items: center;font-size: 14px;cursor: pointer;}
.phone_main .btn_wrap .btn:nth-child(1){border: 1px solid #dddddd;color: #333;}
.phone_main .btn_wrap .btn:nth-child(2){background: #f0413e;color: #fff;}

.password_mask{width: 100%;height: 100%;position: fixed;top: 0;left: 0;background: rgba(0, 0, 0, .5);z-index: 999;transition: all .5s;visibility: hidden;opacity: 0;}
.password_mask.active{visibility: visible;opacity: 1;}
.password_mask .password_main{width: 400px;height: 312px;box-sizing: border-box;padding: 36px 0 28px;background: #fff;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-70%);visibility: hidden;opacity: 0;transition: all .5s;}
.password_mask.active .password_main{transform: translate(-50%,-50%);visibility: visible;opacity: 1;}
.password_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.password_main .title{margin: 0 32px 15px;font-size: 20px;line-height: 1;}
.password_main .input_line{margin: 10px 32px 0;height: 36px;box-sizing: border-box;border: 1px solid #ddd;border-radius: 4px;display: flex;padding: 0 10px;align-items: center;}
.password_main .input_line .txt{width: 76px;font-size: 12px;color: #999999;}
.password_main .input_line .in{flex: 1;width: 0;font-size: 12px;color: #333;}
.password_main .input_line .getcode{padding-left: 8px;border-left: 1px solid #eee;font-size: 12px;color: #333333;cursor: pointer;line-height: 1;}
.password_main .tips{margin: 10px 32px 0;line-height: 1;font-size: 12px;color: #666666;}
.password_main .btn_wrap{margin: 32px 32px 0;display: flex;justify-content: space-between;}
.password_main .btn_wrap .btn{width: 160px;height: 40px;box-sizing: border-box;border-radius: 6px;display: flex;justify-content: center;align-items: center;font-size: 14px;cursor: pointer;}
.password_main .btn_wrap .btn:nth-child(1){border: 1px solid #dddddd;color: #333;}
.password_main .btn_wrap .btn:nth-child(2){background: #f0413e;color: #fff;}

.addAli_mask{width: 100%;height: 100%;position: fixed;top: 0;left: 0;background: rgba(0, 0, 0, .5);z-index: 999;transition: all .5s;visibility: hidden;opacity: 0;}
.addAli_mask.active{visibility: visible;opacity: 1;}
.addAli_mask .addAli_main{width: 400px;height: 380px;box-sizing: border-box;padding: 36px 0 28px;background: #fff;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-70%);visibility: hidden;opacity: 0;transition: all .5s;}
.addAli_mask.active .addAli_main{transform: translate(-50%,-50%);visibility: visible;opacity: 1;}
.addAli_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.addAli_main .title{margin: 0 24px;font-size: 20px;line-height: 1;display: flex;align-items: center;padding-bottom: 15px;}
.addAli_main .title .icon{width: 20px;height: 20px;margin-right: 8px;}
.addAli_main .btn_wrap{margin: 32px 32px 0;display: flex;justify-content: space-between;}
.addAli_main .btn_wrap .btn{width: 160px;height: 40px;box-sizing: border-box;border-radius: 6px;display: flex;justify-content: center;align-items: center;font-size: 14px;cursor: pointer;}
.addAli_main .btn_wrap .btn:nth-child(1){border: 1px solid #dddddd;color: #333;}
.addAli_main .btn_wrap .btn:nth-child(2){background: #f0413e;color: #fff;}

.addBank_mask{width: 100%;height: 100%;position: fixed;top: 0;left: 0;background: rgba(0, 0, 0, .5);z-index: 999;transition: all .5s;visibility: hidden;opacity: 0;}
.addBank_mask.active{visibility: visible;opacity: 1;}
.addBank_mask .addBank_main{width: 400px;height: 428px;box-sizing: border-box;padding: 36px 0 28px;background: #fff;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-70%);visibility: hidden;opacity: 0;transition: all .5s;}
.addBank_mask.active .addBank_main{transform: translate(-50%,-50%);visibility: visible;opacity: 1;}
.addBank_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.addBank_main .title{margin: 0 24px;font-size: 20px;line-height: 1;display: flex;align-items: center;padding-bottom: 15px;}
.addBank_main .title .icon{width: 22px;height: 14px;margin-right: 8px;}
.addBank_main .btn_wrap{margin: 32px 32px 0;display: flex;justify-content: space-between;}
.addBank_main .btn_wrap .btn{width: 160px;height: 40px;box-sizing: border-box;border-radius: 6px;display: flex;justify-content: center;align-items: center;font-size: 14px;cursor: pointer;}
.addBank_main .btn_wrap .btn:nth-child(1){border: 1px solid #dddddd;color: #333;}
.addBank_main .btn_wrap .btn:nth-child(2){background: #f0413e;color: #fff;}
.nodata{font-size: 12px;margin: 30px auto 0;color: #666666;text-align: center;}





.dialog_mask{width: 100%;height: 100%;position: fixed;top: 0;left: 0;background: rgba(0, 0, 0, .5);z-index: 999;transition: all .5s;visibility: hidden;opacity: 0;}
.dialog_mask.active{visibility: visible;opacity: 1;}
.dialog_mask .dialog_main{width: 400px;height: auto;box-sizing: border-box;padding: 36px 0 28px;background: #fff;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-70%);visibility: hidden;opacity: 0;transition: all .5s;}
.dialog_mask.active .dialog_main{transform: translate(-50%,-50%);visibility: visible;opacity: 1;}
.dialog_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.dialog_main .title{margin: 0 32px 15px;font-size: 20px;line-height: 1;}
.dialog_main .input_line{margin: 10px 32px 0;height: 36px;box-sizing: border-box;border: 1px solid #ddd;border-radius: 4px;display: flex;padding: 0 10px;align-items: center;}
.dialog_main .input_line .txt{width: 76px;font-size: 12px;color: #999999;}
.dialog_main .input_line .in{flex: 1;width: 0;font-size: 12px;color: #333;}
.dialog_main .input_line .getcode{padding-left: 8px;border-left: 1px solid #eee;font-size: 12px;color: #333333;cursor: pointer;line-height: 1;}
.dialog_main .tips{margin: 10px 32px 0;line-height: 1;font-size: 12px;color: #666666;}
.dialog_main .btn_wrap{margin: 32px 32px 0;display: flex;justify-content: space-between;}
.dialog_main .btn_wrap .btn{width: 160px;height: 40px;box-sizing: border-box;border-radius: 6px;display: flex;justify-content: center;align-items: center;font-size: 14px;cursor: pointer;}
.dialog_main .btn_wrap .btn:nth-child(1){border: 1px solid #dddddd;color: #333;}
.dialog_main .btn_wrap .btn:nth-child(2){background: #f0413e;color: #fff;}
</style>
<style>
.el_input{display: flex;margin: 12px 32px 0;width: initial;}
.el_input .el-input__inner{height: 38px;line-height: 38px;padding-left: 58px;flex: 1;width: 0;}
.el_input.el_sel .el-input__inner{width: 100%;}
.el_input .el-input__inner:focus , .el-select .el-input.is-focus .el-input__inner{border-color: var(--red);}
.el-select-dropdown__item.selected{color: var(--red);}
.el_input.el_in2 .el-input__inner{padding-left: 110px;}
.el_input.el_in3 .el-input__inner{padding-left: 85px;}
.el_input .el-input__prefix{left: 2px;top: 1px}
.el_input .el-input__prefix .icons{width: 38px;height: 36px;display: flex;justify-content: center;align-items: center;top: 1px;left: 2px;background: #f5f5f5;border-right: 1px solid #ddd;border-radius: 4px 0 0 4px;}
.el_input .el-input__prefix .icons .iconfont{font-size: 20px;color: #cccccc;}
.el_input .el-input__prefix .txts{width: 100%;height: 100%;display: flex;align-items: center;padding-left: 10px;color: #999;}
.el_input .el-input__suffix{display: flex;}
.el_input .el-input__suffix .el-input__suffix-inner{display: flex;align-items: center;}
.el_input .el-input__suffix .el-input__suffix-inner .getcode{font-size: 14px;color: #333333;padding: 0 12px;border-left: 1px solid #ccc;line-height: 1;cursor: pointer;}
.el-descriptions :not(.is-bordered) .el-descriptions-item__cell{padding-bottom: 20px;}
.el-descriptions-item__label:not(.is-bordered-label){margin-right: 30px;}
</style>
